import { render, staticRenderFns } from "./InternationalMedicalVisa.vue?vue&type=template&id=613be757&scoped=true&"
import script from "./InternationalMedicalVisa.vue?vue&type=script&lang=js&"
export * from "./InternationalMedicalVisa.vue?vue&type=script&lang=js&"
import style0 from "./InternationalMedicalVisa.vue?vue&type=style&index=0&id=613be757&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613be757",
  null
  
)

export default component.exports